// UI imports
import PrivatePageLayout from '../../../layout/privatePageLayout/PrivatePageLayout';
import Table from '../../../components/stateful/table/Table';
import CustomButton from '../../../components/stateless/customButton/CustomButton';
import DraftEditForm from './draftEditForm/DraftEditForm';
import { GridDetailRowProps } from '@progress/kendo-react-grid';
import './CodeDrafting.scss';
import { useCodeDraftingController } from './CodeDraftingController';
import CreateDraftModal from './createDraftModal/CreateDraftModal';
import { Loader } from '@progress/kendo-react-indicators';

/**
 *
 * @description Code drafting page that gets wrapped by privatePage layout
 * @returns React.Component
 */
function CodeDrafting() {
  const {
    // state
    selectedDraft,
    viewDrafts,
    columnData,
    openModal,
    // redux
    values,
    fetchingValues,
    title,
    chapter,
    currentFilteredDrafts,
    agency,
    // functions
    // generateColumnData,
    openDraft,
    toggleView,
    toggleModal,
    getDraftDetails,
    createNewDraft,
    updateDraft,
    deleteDraft,
  } = useCodeDraftingController();
  const detailComponent = (detailProps: GridDetailRowProps) => {
    const dataItem = detailProps.dataItem;
    return (
      <div className="filing-detail-panel">
        <div>
          <div className='filing-detail-header'>
            <b>Draft Details: {dataItem.draftName}</b>
            <CustomButton fillMode='solid' icon="hyperlink-open" themeColor="primary" onClick={(event) => openDraft(event, dataItem)} >
              Open Draft
            </CustomButton>
            <CustomButton fillMode='solid' icon="x-circle" themeColor="error" onClick={() => deleteDraft(dataItem.id)} >
              Delete Draft
            </CustomButton>
          </div>
          <div className="filing-detail-card">
            <div>
              <b>Agency:</b> {agency ? agency.agencyName : (<Loader />)}
            </div>
            <div>
              <b>Title:</b> {title
                ? `${title?.titleNumber} ${title.titleName ? "- " + title?.titleName : ''}`
                : (<Loader />)}
            </div>
            {/* <div>
              <b>Chapter:</b> {chapter?.chapterName ?? (<Loader />)}
            </div> */}
            <div className="horizontal-divider" />
          </div>
        </div>
      </div>
    )
  };

  const onDetailExpand = (dataItem: any) => {
    getDraftDetails(dataItem);
  }

  const renderCodeDrafting = () => {
    return (
      <div>
        {viewDrafts && columnData ? (
          <Table
            values={currentFilteredDrafts}
            columns={columnData}
            tableName="Code Drafting"
            height="83svh"
            details={detailComponent}
            onClickAdd={toggleModal}
            onDetailExpandChange={onDetailExpand}
            isLoading={fetchingValues}
            onClickAddText='Create New Draft'
          />
        ) : (
          <DraftEditForm draft={selectedDraft} />
        )}
      </div>
    );
  }

  const renderDraftModal = () => {
    return (
      <CreateDraftModal
        toggleDialog={toggleModal}
        open={openModal}
        title="Create Draft"
        approveAction={createNewDraft}
        cancelAction={toggleModal}
        updateDraft={updateDraft}
      />
    );
  }

  return (
    <PrivatePageLayout>
      {!viewDrafts ? (
        <CustomButton onClick={toggleView} icon="chevron-left" fillMode='flat' themeColor='primary' >Back</CustomButton>
      ) :
        null
      }
      {openModal ?
        renderDraftModal()
        : null}
      {renderCodeDrafting()}
    </PrivatePageLayout>
  )
}

export default CodeDrafting
